import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resetPassword } from '../Login/services/fakeAuthService';

const NewPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('Password tidak cocok.');
      return;
    }

    const email = localStorage.getItem('resetEmail');
    if (!email) {
      setError('Email tidak ditemukan. Ulangi proses dari awal.');
      return;
    }

    try {
      await resetPassword(email, newPassword);
      setSuccess('Password berhasil diubah. Silakan login.');
      localStorage.removeItem('resetEmail');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-gradient-to-br from-green-100 to-green-300">
      <div className="w-full max-w-md p-8 bg-white shadow-2xl rounded-3xl animate-fade-in">
        <h2 className="mb-6 text-2xl font-bold text-center text-green-700">🔒 Password Baru</h2>
        <form onSubmit={handleReset} className="space-y-6">
          <div>
            <label className="block mb-1 text-sm font-semibold text-green-800">Password Baru</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-3 py-2 border border-green-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-semibold text-green-800">Konfirmasi Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-3 py-2 border border-green-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>
          {error && <div className="text-sm text-center text-red-600">{error}</div>}
          {success && <div className="text-sm text-center text-green-600">{success}</div>}

          <button
            type="submit"
            className="w-full py-2 font-semibold text-white transition duration-300 bg-green-600 shadow-md hover:bg-green-700 rounded-xl"
          >
            Simpan Password Baru
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewPassword;
